import {createListCollection, HStack, Icon, Portal, Select} from "@chakra-ui/react";
import {HiOutlineGlobeAsiaAustralia} from "react-icons/hi2";
import {useTranslation} from "react-i18next";
import {SUPPORTED_LANGUAGES} from "@/i18n";

const LanguageSelector = () => {
    const {i18n, t} = useTranslation();

    const languageCollection = createListCollection({
        items: SUPPORTED_LANGUAGES.map((code) => ({
            value: code,
            label: t(`language.${code}`),
        })),
    });

    const currentLanguage = SUPPORTED_LANGUAGES.includes(i18n.language)
        ? i18n.language
        : SUPPORTED_LANGUAGES[0];

    return (
        <HStack w={'100%'} px={3}>
            <Icon size={'lg'} color={'text.user'}>
                <HiOutlineGlobeAsiaAustralia />
            </Icon>
            <Select.Root
                collection={languageCollection}
                value={[currentLanguage]}
                size={"sm"}
                onValueChange={(e) => i18n.changeLanguage(e.value[0])}
            >
                <Select.HiddenSelect />
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText placeholder={t('language.select')} color={"text.user"} />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator />
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {languageCollection.items.map((language) => (
                                <Select.Item item={language} key={language.value} color={"text.user"} >
                                    {language.label}
                                    <Select.ItemIndicator />
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </HStack>
    )
}

export default LanguageSelector;
